import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ColorComparisonPage() {
  return <div className="w-full bg-[#f8f8f8]" data-id="element-715">
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-716">
        <Link to="/" className="flex items-center text-gray-600 hover:text-[#214ae9] transition-colors font-medium" data-id="element-717">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-718" />
          <span data-id="element-719">Go Back</span>
        </Link>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-16" data-id="element-720">
        <div className="text-center mb-12" data-id="element-721">
          <h1 className="text-4xl md:text-5xl font-bold text-[#111111] mb-4" data-id="element-722">
            Color Strategy Options
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-723">
            Explore different approaches to using your brand colors. Each option
            shows a unique hierarchy and emphasis.
          </p>
        </div>

        <div className="space-y-16" data-id="element-724">
          {/* Option 1: Blue Primary (Current) */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-725">
            <div className="bg-[#1a0647] px-8 py-4 border-b border-gray-700" data-id="element-726">
              <h2 className="text-xl font-bold text-white" data-id="element-727">
                Option 1: Blue Primary
              </h2>
              <p className="text-sm text-gray-300" data-id="element-728">
                Professional and trustworthy • Current implementation
              </p>
            </div>
            <div className="p-8" data-id="element-729">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-730">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-731">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-732">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-733">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-734">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-735">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-lg flex items-center space-x-2" data-id="element-736">
                      <span data-id="element-737">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-738" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-739">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-740">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-741">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-742">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-743" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-744">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-745">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-746">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-747">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-748" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-749">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-750">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 2: Purple Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-751">
            <div className="bg-[#b063ff] px-8 py-4 border-b border-purple-400" data-id="element-752">
              <h2 className="text-xl font-bold text-white" data-id="element-753">
                Option 2: Purple Primary
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-754">
                Modern and energetic • Bold personality
              </p>
            </div>
            <div className="p-8" data-id="element-755">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-756">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-757">
                  <div className="inline-block bg-[#00f4f8] bg-opacity-20 text-[#00f4f8] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#00f4f8] border-opacity-30" data-id="element-758">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-759">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-760">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-761">
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg flex items-center space-x-2" data-id="element-762">
                      <span data-id="element-763">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-764" />
                    </button>
                    <button className="border-2 border-[#214ae9] text-[#214ae9] px-6 py-3 rounded-lg font-bold hover:bg-[#214ae9] hover:text-white transition-all" data-id="element-765">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-766">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-767">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-768">
                      <ShieldIcon className="w-6 h-6 text-[#b063ff]" data-id="element-769" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-770">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-771">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-772">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-773">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-774" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-775">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-776">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 3: Cyan Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-777">
            <div className="bg-[#00f4f8] px-8 py-4 border-b border-cyan-300" data-id="element-778">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-779">
                Option 3: Cyan Primary
              </h2>
              <p className="text-sm text-[#111111] text-opacity-70" data-id="element-780">
                Fresh and innovative • High energy
              </p>
            </div>
            <div className="p-8" data-id="element-781">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-782">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-783">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-784">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-785">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-786">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-787">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-[#00d9dd] transition-all shadow-lg flex items-center space-x-2" data-id="element-788">
                      <span data-id="element-789">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-790" />
                    </button>
                    <button className="border-2 border-[#b063ff] text-[#b063ff] px-6 py-3 rounded-lg font-bold hover:bg-[#b063ff] hover:text-white transition-all" data-id="element-791">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-792">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-793">
                    <div className="w-12 h-12 bg-[#00f4f8] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-794">
                      <ShieldIcon className="w-6 h-6 text-[#00f4f8]" data-id="element-795" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-796">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-797">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-798">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-799">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-800" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-801">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-802">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 4: Balanced Trio */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-803">
            <div className="bg-gradient-to-r from-[#214ae9] via-[#b063ff] to-[#00f4f8] px-8 py-4" data-id="element-804">
              <h2 className="text-xl font-bold text-white" data-id="element-805">
                Option 4: Balanced Trio
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-806">
                Equal emphasis • Vibrant and dynamic
              </p>
            </div>
            <div className="p-8" data-id="element-807">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-808">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-809">
                  <div className="inline-block bg-white bg-opacity-10 text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-white border-opacity-20" data-id="element-810">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-811">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-812">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-813">
                    <button className="bg-gradient-to-r from-[#214ae9] to-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:shadow-xl transition-all shadow-lg flex items-center space-x-2" data-id="element-814">
                      <span data-id="element-815">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-816" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-817">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-818">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-819">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-820">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-821" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-822">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-823">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-824">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-825">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-826" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-827">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-828">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 5: High Contrast */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-829">
            <div className="bg-[#111111] px-8 py-4 border-b border-gray-800" data-id="element-830">
              <h2 className="text-xl font-bold text-white" data-id="element-831">
                Option 5: High Contrast
              </h2>
              <p className="text-sm text-gray-400" data-id="element-832">
                Bold and striking • Maximum impact
              </p>
            </div>
            <div className="p-8" data-id="element-833">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-834">
                {/* Hero preview */}
                <div className="bg-[#111111] rounded-xl p-8 border-2 border-[#00f4f8]" data-id="element-835">
                  <div className="inline-block bg-[#00f4f8] text-[#111111] px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-836">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-837">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-838">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-839">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-white transition-all shadow-lg flex items-center space-x-2" data-id="element-840">
                      <span data-id="element-841">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-842" />
                    </button>
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg" data-id="element-843">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-844">
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-845">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-846">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-847" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-848">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-849">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-850">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-851">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-852" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-853">
                      Easy to Use
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-854">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 6: Light & Airy */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-855">
            <div className="bg-white px-8 py-4 border-b-2 border-[#214ae9]" data-id="element-856">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-857">
                Option 6: Light & Airy
              </h2>
              <p className="text-sm text-gray-600" data-id="element-858">
                Minimal and clean • Approachable
              </p>
            </div>
            <div className="p-8" data-id="element-859">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-860">
                {/* Hero preview */}
                <div className="bg-white rounded-xl p-8 border-2 border-gray-200" data-id="element-861">
                  <div className="inline-block bg-[#214ae9] bg-opacity-5 text-[#214ae9] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#214ae9] border-opacity-20" data-id="element-862">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-[#111111] mb-4" data-id="element-863">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-864">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-865">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-md flex items-center space-x-2" data-id="element-866">
                      <span data-id="element-867">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-868" />
                    </button>
                    <button className="bg-white border-2 border-gray-300 text-[#111111] px-6 py-3 rounded-lg font-bold hover:border-[#214ae9] hover:text-[#214ae9] transition-all" data-id="element-869">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-870">
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#214ae9] transition-colors" data-id="element-871">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-872">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-873" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-874">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-875">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#b063ff] transition-colors" data-id="element-876">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-877">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-878" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-879">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-880">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}